import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEye = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.0001 18.8334C6.35229 18.8334 1.31971 12.9629 1.10796 12.7126C0.964013 12.5412 0.964013 12.2909 1.10796 12.1204C1.31974 11.8703 6.35229 6 12.0001 6C18.5821 6 22.7453 11.9043 22.9185 12.1565C23.0368 12.327 23.0249 12.5552 22.892 12.713C22.6802 12.9631 17.6476 18.8334 11.9999 18.8334H12.0001ZM2.0744 12.4168C3.16798 13.5994 7.47273 17.9169 12.0001 17.9169C16.5659 17.9169 20.8957 13.5368 21.9497 12.392C21.0366 11.2279 17.2974 6.91671 12.0001 6.91671C7.46605 6.91671 3.16617 11.2335 2.0744 12.4168Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.0002 16.0828C9.97798 16.0828 8.3335 14.4384 8.3335 12.4162C8.3335 10.394 9.97798 8.74951 12.0002 8.74951C14.0223 8.74951 15.6668 10.394 15.6668 12.4162C15.6668 14.4384 14.0223 16.0828 12.0002 16.0828ZM12.0002 9.66622C10.4839 9.66622 9.25012 10.9 9.25012 12.4163C9.25012 13.9325 10.4839 15.1663 12.0002 15.1663C13.5164 15.1663 14.7502 13.9325 14.7502 12.4163C14.7502 10.9 13.5164 9.66622 12.0002 9.66622V9.66622Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgEye;
